import { render, staticRenderFns } from "./BostonLogin.vue?vue&type=template&id=b8ad6956&scoped=true"
import script from "./BostonLogin.vue?vue&type=script&lang=js"
export * from "./BostonLogin.vue?vue&type=script&lang=js"
import style0 from "./BostonLogin.vue?vue&type=style&index=0&id=b8ad6956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ad6956",
  null
  
)

export default component.exports